<script>
import { debounce } from "lodash";
import { findData } from "@/utils/common";
import { formAutoCompleteConfig } from "@/components/base/conf";

export default {
  name: "formAutoComplete",
  components: {},
  props: {
    //值
    value: {
      type: String,
      default: ""
    },
    //标题
    title: {
      type: String,
      default: ""
    },
    //标题宽度
    titleWidth: {
      type: String,
      default: ""
    },
    //数据
    data: {
      type: Array,
      default: () => []
    },
    //请求接口
    api: {
      type: Function,
      default: null
    },
    //请求参数
    param: {
      type: Object,
      default: () => ({})
    },
    //搜索值 对应key  用于api请求传参
    valueField: {
      type: String,
      default: formAutoCompleteConfig.valueField
    },
    //数据来源
    dataField: {
      type: String,
      default: formAutoCompleteConfig.dataField
    },
    //提示
    placeholder: {
      type: String,
      default: ""
    },
    //必填
    required: {
      type: Boolean,
      default: false
    },
    //只读
    readonly: {
      type: Boolean,
      default: false
    },
    //禁用
    disabled: {
      type: Boolean,
      default: false
    },
    //请求之前
    optionsLoadBefore: {
      type: Function,
      default: null
    },
    //请求之后
    optionsLoadAfter: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      list: [],
      visible: false,
      realValue: ""
    };
  },
  watch: {
    realValue(e) {
      if (this.realValue != this.value) {
        this.$emit("input", e);
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    },
    data() {
      this.list = this.data;
    }
  },
  created() {
    this.realValue = this.value;
  },
  mounted() {
    document.addEventListener("click", this.popupHidden);
  },
  destroyed() {
    document.removeEventListener("click", this.popupHidden);
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e;
    },
    /**
     * @description: 选中
     * @param {*} row
     * @return {*}
     */
    selectItem(row) {
      this.$emit("select", row);
      this.popupHidden();
    },
    /**
     * @description: 隐藏
     * @param {*}
     * @return {*}
     */
    popupHidden() {
      this.visible = false;
    },
    /**
     * @description: 改变时
     * @param {*} function
     * @return {*}
     */
    onChange: debounce(function() {
      let { realValue } = this;
      this.$emit("change", realValue);
      if (!realValue) return;
      this.onLoad();
    }, 200),
    /**
     * @description: 请求
     * @param {*}
     * @return {*}
     */
    onLoad() {
      let { api, data, optionsLoadAfter } = this;
      if (api) {
        let { dataField, optionsLoadBefore } = this;
        let params = {
          ...this.param
        };
        params[this.valueField] = this.realValue;
        if (optionsLoadBefore) {
          params = optionsLoadBefore(params);
          if (params === false) return;
        }
        api(params).then(res => {
          let data = dataField ? findData(res, dataField) : res;
          if (optionsLoadAfter) data = optionsLoadAfter(data);
          if (data && data.length > 0) {
            this.list = data;
            this.visible = true;
          }
        });
      } else {
        if (optionsLoadAfter) data = optionsLoadAfter(data);
        if (data && data.length > 0) {
          this.list = data;
          this.visible = true;
        }
      }
    },
    /**
     * @description: 输入框 渲染
     * @param {*} h
     * @return {*}
     */
    fieldRender(h) {
      let { disabled, readonly } = this;
      readonly = readonly || disabled;
      let option = {
        props: {
          label: this.title,
          value: this.realValue,
          required: this.required,
          labelWidth: this.titleWidth,
          readonly
        },
        ref: "input"
      };
      if (!readonly) {
        option.props.placeholder = this.placeholder;
        let listeners = {};
        for (const key in this.$listeners) {
          listeners[key] = (...arg) => {
            this.$emit(key, ...arg);
          };
        }
        option.on = {
          ...listeners,
          input: e => {
            this.realValue = e;
            this.onChange();
          }
        };
      }
      return h("van-field", option);
    },
    /**
     * @description: 弹窗 渲染
     * @param {*} h
     * @return {*}
     */
    popupRender(h) {
      let { visible, $scopedSlots: slots, popupItemRender } = this;
      if (visible && slots.default) {
        return h(
          "div",
          {
            class: "popup",
            props: {
              value: visible
            }
          },
          [popupItemRender(h)]
        );
      }
    },
    /**
     * @description: 弹出内容 渲染
     * @param {*} h
     * @return {*}
     */
    popupItemRender(h) {
      let { $scopedSlots: slots, list, selectItem } = this;
      return list.map(p => {
        return h(
          "div",
          {
            class: "item",
            on: {
              click: e => {
                e.stopPropagation();
                selectItem(p);
              }
            }
          },
          [slots.default(p)]
        );
      });
    }
  },
  render(h) {
    let { fieldRender, popupRender } = this;
    return h("div", { class: "autoComplete van-cell" }, [
      fieldRender(h),
      popupRender(h)
    ]);
  }
};
</script>

<style lang="less" scoped>
.autoComplete {
  position: relative;
  padding: 0;
  overflow: initial;
  .popup {
    position: absolute;
    left: 0;
    top: 44px;
    width: 100%;
    overflow-y: auto;
    border: 0 solid @lightGray;
    border-width: 0 0 1px 0;
    background: @white;
    z-index: 1;
  }
}
</style>
